import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'
import { enter } from '@/lib/motion'
import { HeroHeading } from '@/components/site/hero-heading'
import { heroIntro } from '@/constants/home'
import { media } from '@/constants/media'

export const HomeHero: FC = (): ReactNode => {
    return (
        <section
            id='hero'
            className='sticky top-0 z-[1] flex h-svh min-h-[560px] w-full flex-col items-center justify-center overflow-clip bg-coal'
        >
            <div className='hero-video-mask absolute inset-0'>
                <img
                    src={media.heroImage}
                    alt=""
                    fetchPriority='high'
                    decoding='async'
                    className='animate-drift absolute inset-0 size-full bg-coal object-cover'
                />

                <div aria-hidden='true' className='absolute inset-0 bg-black/45' />
            </div>

            <div className='relative z-[1] flex w-full flex-col items-center gap-6 px-4 md:gap-8'>
                <HeroHeading
                    first="Engineering"
                    connector="for"
                    second="Real life"
                    tone='light'
                />

                <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={enter(0.6)}
                    className='t-italic max-w-[520px] text-center text-cream'
                >
                    {heroIntro}
                </motion.p>
            </div>

            <motion.div
                className='absolute inset-x-0 bottom-0 z-[1] flex flex-col items-center gap-1 p-4 md:gap-1.5'
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={enter(0.8)}
            >
                <p className='t-italic text-center text-cream'>
                    Scroll down
                </p>

                <a
                    href='#about'
                    aria-label="Scroll to the introduction"
                    className='flex size-6 items-center justify-center text-cream'
                >
                    <svg viewBox='0 0 26 26' className='animate-chevron size-6' aria-hidden='true'>
                        <path
                            d='M0 0 L9 7.2 L18 0'
                            transform='translate(4 10)'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth={2}
                        />
                    </svg>
                </a>
            </motion.div>
        </section>
    )
}
